export const mailFolder = {
  data() {
    return {
    };
  },
  methods: {

    /**
     * Function to expand/collapse a folder tree.
     */
    setExpandable(folderList, expandFlag) {
      folderList.forEach(folder1 => {
        folder1.expandFlag = expandFlag;
        if(folder1.folders) {
          folder1.folders.forEach(folder2 => {
            folder2.expandFlag = expandFlag;
            if(folder2.folders) {
              folder2.folders.forEach(folder3 => {
                folder3.expandFlag = expandFlag;
                if(folder3.folders) {
                  folder3.folders.forEach(folder4 => {
                    folder4.expandFlag = expandFlag;
                  });
                }
              });
            }
          });
        }
      });
      return folderList;
    },

    getHtmlContent(mailDetail, msgType) {
      return '<p id="startParagraphForward"><br></p>' +
                      `<p class="paddingTop" id="forwardMsgDottedLine"> - - - - - - - - - - ${msgType} - - - - - - - - - - </p>` +
                      '<div class="forwardedMessage" id="forwardedMessageDiv">' +
                        '<div class="padBot">' +
                          this.fromNameHtml(mailDetail) +
                          this.sentTimeHtml(mailDetail) +
                          this.subjectHtml(mailDetail) +
                          this.toHtml(mailDetail) +
                          this.ccHtml(mailDetail) +
                          this.bccHtml(mailDetail) +
                        '</div>' +
                        `<p class="padTopBot">${mailDetail.message}</p>` +
                      '</div>';
    },

    fromNameHtml(mailDetail) {
      let html = ``;
      if(mailDetail.fromName) {
        html = `<td>From:&nbsp;<span class="bold">${mailDetail.fromName}</span>` +
                   this.fromEmailHtml(mailDetail) +
               '<br></td>'
      }

      return html;
    },

    fromEmailHtml(mailDetail) {
      let html = ``;
      if(mailDetail.fromEmail) {
        html = `&lt;${mailDetail.fromEmail}&gt;`;
      }

      return html;
    },

    sentTimeHtml(mailDetail) {
      let html = ``;
      if(mailDetail.sentTime) {
        html = `<td class="showTimeType">Date:&nbsp;${mailDetail.sentTime}<br></td>`;
      }

      return html;
    },

    subjectHtml(mailDetail) {
      let html = ``;
      if(mailDetail.subject) {
        html = `<td style="min-width:5%;">Subject:&nbsp;</td>
                <td>${mailDetail.subject}<br/></td>`;
      }

      return html;
    },

    toHtml(mailDetail) {
      let toEmail = '';

      if(mailDetail.to && (mailDetail.to.length > 0)) {
        toEmail = '<td>To:&nbsp;</td><td>';

        mailDetail.to.forEach((to, index) => {

          let email = `${to.name} &lt;${to.email}&gt;`;

          if(index !== (mailDetail.to.length-1)) {
            email += ',';
          }

          toEmail += email;
        });

        toEmail += '<br/></td>'

      }

      return toEmail;
    },

    ccHtml(mailDetail) {
      let ccEmail = '';

      if(mailDetail.cc && (mailDetail.cc.length > 0)) {
        ccEmail = '<td>CC:&nbsp;</td><td>';

        mailDetail.cc.forEach((cc, index) => {

          let email = `${cc.name} &lt;${cc.email}&gt;`;

          if(index !== (mailDetail.cc.length-1)) {
            email += ',';
          }

          ccEmail += email;
        });

        ccEmail += '<br/></td>'

      }

      return ccEmail;
    },

    bccHtml(mailDetail) {
      let bccEmail = '';

      if(mailDetail.bcc && (mailDetail.bcc.length > 0)) {
        bccEmail = '<td>BCC:&nbsp;</td><td>';

        mailDetail.bcc.forEach((bcc, index) => {

          let email = `${bcc.name} &lt;${bcc.email}&gt;`;

          if(index !== (mailDetail.bcc.length-1)) {
            email += ',';
          }

          bccEmail += email;
        });

        bccEmail += '</td>'

      }

      return bccEmail;
    }
  }
};
